import { z } from "zod";
import { adminOperationsPilotSchemaVersionSchema } from "./admin-operations-core.js";
import { customerActivityMetricNames } from "./customer-activity.js";
const utcDaySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/u);
const environmentSchema = z.enum(["LIVE", "TEST_SANDBOX"]);
export const adminActivityOverviewCommandSchema = z
    .object({
    from: utcDaySchema,
    to: utcDaySchema,
    environment: environmentSchema.default("TEST_SANDBOX"),
    // Opt-in extension: existing strict clients must keep their original response shape.
    includeCoverage: z.boolean().optional(),
})
    .strict()
    .superRefine((value, context) => {
    const from = Date.parse(`${value.from}T00:00:00.000Z`);
    const to = Date.parse(`${value.to}T00:00:00.000Z`);
    if (!Number.isFinite(from) || !Number.isFinite(to) || from > to)
        context.addIssue({ code: "custom", message: "The activity reporting range is invalid." });
    if (to - from > 89 * 24 * 60 * 60 * 1_000)
        context.addIssue({ code: "custom", message: "Activity reporting is limited to 90 days." });
});
const metricFields = Object.fromEntries(customerActivityMetricNames.map((name) => [name, z.number().int().nonnegative()]));
export const adminActivityMetricDaySchema = z
    .object({ date: utcDaySchema, ...metricFields })
    .strict();
export const adminActivityOverviewResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminOperationsPilotSchemaVersionSchema,
        environment: environmentSchema,
        completeness: z.literal("FORWARD_ONLY"),
        trackingStartedAt: z.string().datetime(),
        from: utcDaySchema,
        to: utcDaySchema,
        totals: adminActivityMetricDaySchema.omit({ date: true }),
        insights: z
            .object({
            voucherToBookBasisPoints: z.number().int().min(0).max(10_000),
            studioToGenerationBasisPoints: z.number().int().min(0).max(10_000),
            generationCompletionBasisPoints: z.number().int().min(0).max(10_000),
            printToSubmissionBasisPoints: z.number().int().min(0).max(10_000),
            submissionToDeliveryBasisPoints: z.number().int().min(0).max(10_000),
            lastActivityAt: z.string().datetime().nullable(),
        })
            .strict(),
        days: z.array(adminActivityMetricDaySchema).max(90),
        coverage: z
            .object({
            status: z.literal("PARTIAL"),
            population: environmentSchema,
            basis: z.literal("EVENT_TIME_UTC_DAY"),
            activeCustomerUnit: z.literal("CUSTOMER_DAYS_NOT_UNIQUE_PEOPLE"),
            metricShards: z.number().int().positive().max(64),
            legacyBucketIncluded: z.boolean(),
            observedDays: z.array(utcDaySchema).max(90),
            missingDays: z.array(utcDaySchema).max(90),
            completenessWatermark: z.null(),
            reasons: z.array(z.string()).max(10),
        })
            .strict()
            .optional(),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-operations-activity.js.map